module.exports = __webpack_public_path__ + "img/ts2.f20948ea.png";